import React from "react";
import dynamic from "next/dynamic";
import NewsPage from "@components/Pages/NewsPage";
import { Leaf } from "@components/Leaf/Leaf";
import styles from "@components/Pages/NewsPage/NewsPage.module.scss";
import LaufidLoader from "@components/LaufidLoader/LaufidLoader";

const Page = dynamic(() => import("@components/Layout/page"), {
    loading: () => <LaufidLoader />,
});

export default function News() {
    return (
        <div style={{ overflowX: "hidden" }}>
            <Page fluid bodyClassName={styles.pageBody}>
                <div className={styles.bgContainer}>
                    <Leaf className={styles.leaf1} plain />
                    <Leaf className={styles.leaf2} plain />
                    <Leaf className={styles.leaf3} plain />
                    <div className={styles.topGradient} />
                    <NewsPage />
                </div>
            </Page>
        </div>
    );
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../../locales/${locale}.json`)).default,
        },
    };
}
